<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-11 16:01:03
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-16 11:00:05
 * @Description: 复制组件
-->
<template>
  <span class="text">
    {{ text }}
    <a
      class="copyable-icon"
      v-clipboard:copy="text"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    ></a>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 复制成功
    onCopy () {
      this.$message.success(this.$t('message.copySuccess'))
    },
    // 复制失败
    onError () {
      this.$message.error(this.$t('message.copySuccess'))
    }
  }
}
</script>

<style lang="scss" scoped>
.text{
  display: flex;
  align-items: center;
}
.copyable-icon {
  position: relative;
  display: inline-block;
  margin: 0 4px;
  width: 14px;
  height: 14px;
  background: url(../../assets/img/copy.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}
</style>
